import { CodeIcon } from "@heroicons/react/outline";
import { LightningBoltIcon } from "@heroicons/react/outline";
import * as yup from "yup";
import { getTranslationPayload as t } from "src/i18n";
import { ERROR_MESSAGES } from "../../constants/Form";

interface InboxActionType {
  value: string;
  label: string[];
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

export const INBOX_ACTION_TYPES: InboxActionType[] = [
  {
    value: "HTTP",
    label: t("inbox-actions:builder.http-request-label", "HTTP Request"),
    icon: CodeIcon,
  },
  {
    value: "FLOW",
    label: t("inbox-actions:builder.trigger-flow-label", "Trigger Flow"),
    icon: LightningBoltIcon,
  },
];

export const InboxAction = {
  getInitialValues: function (t, actionType = "HTTP") {
    return {
      name: "",
      action_type: actionType,
      button_label: t(
        "inbox-actions:builder.default-button-label",
        "My Action"
      ),
      related_flow: "",
    };
  },
  FIELDS: {
    name: {
      key: "name",
      label: t("inbox-actions:builder.name-label", "Name of this action"),
      placeholder: t(
        "inbox-actions:builder.name-placeholder",
        "Create ticket on Zendesk"
      ),
      optional: false,
      help: t("inbox-actions:builder.name-help", ""),
    },
    button_label: {
      key: "button_label",
      placeholder: t("inbox-actions:builder.default-button-label", "My Action"),
      label: t(
        "inbox-actions:builder.button-label-label",
        "What will the button label be?"
      ),
      help: t(
        "inbox-actions:builder.button-label-help",
        "This is how your teammates will be able to see it in the Inbox > Actions tab."
      ),
      optional: false,
    },
    action_type: {
      key: "action_type",
      label: t("inbox-actions:builder.action-type-label", "Action Type"),
      help: t(
        "inbox-actions:builder.action-type-help",
        "Select the type of action this button will perform."
      ),
      optional: false,
      options: INBOX_ACTION_TYPES.map((actionType) => ({
        value: actionType.value,
        label: actionType.label,
        icon: actionType.icon,
        disabled: false,
      })),
    },
  },
  schema: {
    name: yup.string().required(ERROR_MESSAGES.required),
    action_type: yup.string().required(ERROR_MESSAGES.required),
    button_label: yup.string().required(ERROR_MESSAGES.required),
    related_flow: yup.string().when("action_type", {
      is: "FLOW",
      then: () =>
        yup.string().required("Flow is required when action type is FLOW"),
    }),
  },
};
